import React, { Component } from 'react';
import MediaModal, { ModalType } from '../MediaModal/MediaModal';
import './Teaser.css';

export default class Teaser extends Component {
    constructor(props) {
        super(props);
        this.state = {
            displayModal: false
        }
        this.closeModal = this.closeModal.bind(this);
        this.onImageClick = this.onImageClick.bind(this);
    }

    closeModal() {
        this.setState({
            displayModal: false
        })
    }

    displayModalForm() {
        return (this.props.formUrl)
    }

    displayModalVideo() {
        return (this.props.localVideoUrl || this.props.videoEmbed)
    }

    displayModalImage() {
        return (!this.displayModalVideo() && !this.props.teaserUrl && this.props.imageUrl);
    }

    onImageClick() {
        this.setState({
            displayModal: true
        })
    }

    render() {
        let imageClass = "";

        if(!this.props.imageUrl && !this.displayModalVideo() && !this.displayModalImage()) {
            imageClass = "single-teaser-image--no-image"
        }

        const singleTeaserImageStyle = {
            backgroundPosition: 'center',
            backgroundSize: `${this.props.isYtVideo? 'cover' : 'contain'}`,
            backgroundRepeat: 'no-repeat',
            backgroundImage: "url(" + this.props.imageUrl + ")",
        };

        return (
            <div className="single-teaser">
                {
                    this.displayModalVideo() || this.displayModalImage() || this.displayModalForm() ?
                    <figure>
                        <div className={"img-flow ratio-16-9 single-teaser-image " + imageClass} style={singleTeaserImageStyle}>
                            {this.displayModalVideo() && <div className="image-overlay video-play" onClick={this.onImageClick} />}
                            {this.displayModalImage() && <div className="image-overlay image-open" onClick={this.onImageClick} />}
                            {this.displayModalForm() && <div className="image-overlay form-open" onClick={this.onImageClick} />}
                        </div>
                    </figure> :
                    <a href={this.props.teaserUrl} target="_blank" rel="noopener noreferrer">
                        <figure>
                            <div className={"img-flow ratio-16-9 single-teaser-image " + imageClass} style={singleTeaserImageStyle}></div>
                        </figure>
                    </a>
                }

                <div className="flowList__item-content single-teaser-content">
                    <h4 className="heading heading--quaternary single-teaser-growing-header">
                        {this.props.teaserUrl && <a href={this.props.teaserUrl} target="_blank" rel="noopener noreferrer">{this.props.teaserText}</a>}
                        {!this.props.teaserUrl && <div>{this.props.teaserText}</div>}
                    </h4>
                    {this.props.teaserDetails && <div className="preview-intro">{this.props.teaserDetails}</div>}
                    {this.props.children}

                    <MediaModal
                        displayMode={this.displayModalVideo() ? ModalType.VIDEO : this.displayModalForm() ? ModalType.FORM : ModalType.IMAGE}
                        isOpen={this.state.displayModal}
                        onRequestClose={this.closeModal}
                        localVideoUrl={this.props.localVideoUrl}
                        embedCode={this.props.videoEmbed}
                        imageUrl={this.props.imageUrl}
                        formUrl={this.props.formUrl}
                    />
                </div>
            </div>
        );
    }
}